export var hexToRGBA = function (hex, alpha) {
    var hexCode = hex.replace(/[^0-9A-Za-z.]+/g, '');
    var r = parseInt(hexCode.slice(0, 2), 16);
    var g = parseInt(hexCode.slice(2, 4), 16);
    var b = parseInt(hexCode.slice(4, 6), 16);
    if (alpha) {
        return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", .").concat(alpha, ")");
    }
    return "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")");
};
//# sourceMappingURL=colors.js.map